import { render, staticRenderFns } from "./PromoSept2022.vue?vue&type=template&id=3e001f78&"
import script from "./PromoSept2022.vue?vue&type=script&lang=js&"
export * from "./PromoSept2022.vue?vue&type=script&lang=js&"
import style0 from "./PromoSept2022.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VDataTable})
